/**
 * styles-data.js
 * Cấu hình 4 phong cách đồ họa nghệ thuật và thông số ánh sáng, sương mù, texture.
 */

export const STYLES_DATA = {
  pixel: {
    id: 'pixel',
    name: 'Pixel Art',
    icon: '👾',
    bg: '/assets/2.5d-layers/pixel_sky_bg.jpg',
    isPixel: true,
    bgColor: 0x161829,
    fogColor: 0x161829,
    fogDensity: 0.007,
    dirColor: 0xffe29a,
    dirIntensity: 1.45,
    ambColor: 0xb0c4de,
    ambIntensity: 0.7,
    cyberNeon: false
  },
  ghibli: {
    id: 'ghibli',
    name: 'Anime Ghibli',
    icon: '🍃',
    bg: '/assets/2.5d-layers/ghibli_sky_bg.jpg',
    isPixel: false,
    bgColor: 0x98d4f7,
    fogColor: 0xbae6fd,
    fogDensity: 0.005,
    dirColor: 0xfffaed,
    dirIntensity: 1.6,
    ambColor: 0xe0f2fe,
    ambIntensity: 0.8,
    cyberNeon: false
  },
  paper: {
    id: 'paper',
    name: 'Paper Cutout',
    icon: '✂️',
    bg: '/assets/2.5d-layers/paper_sky_bg.jpg',
    isPixel: false,
    bgColor: 0xf5ebd9,
    fogColor: 0xf2e4ce,
    fogDensity: 0.006,
    dirColor: 0xffedd5,
    dirIntensity: 1.5,
    ambColor: 0xfff7ed,
    ambIntensity: 0.85,
    cyberNeon: false
  },
  cyber: {
    id: 'cyber',
    name: 'Cyberpunk Neon',
    icon: '⚡',
    bg: '/assets/2.5d-layers/cyber_sky_bg.jpg',
    isPixel: false,
    bgColor: 0x080616,
    fogColor: 0x0c0920,
    fogDensity: 0.012,
    dirColor: 0x6366f1,
    dirIntensity: 0.85,
    ambColor: 0x2e1065,
    ambIntensity: 0.45,
    cyberNeon: true
  }
};

// Dữ liệu 4 căn nhà Modular cho từng phong cách, xếp so le trục Z
// Nhà 1: X = -13.5, Z = -9.2
// Nhà 2: X = -4.5,  Z = -8.7 (nhô lên 0.5m che mép Nhà 1 & Nhà 3)
// Nhà 3: X = +3.5,  Z = -9.4 (lùi lại 0.7m)
// Nhà 4: X = +12.5, Z = -8.9 (nhô lên 0.5m che mép Nhà 3)
// Kích thước chiều rộng được căn chỉnh để các căn nhà gối mép nhẹ lên nhau,
// tạo thành dãy phố liền kề và kích hoạt hiệu ứng trượt che khuất (Occlusion Parallax) tự nhiên khi camera lia!
export const MODULAR_HOUSES_CONFIG = {
  ghibli: [
    {
      file: '/assets/2.5d-layers/ghibli_bldg_1_cafe.png',
      x: -13.5,
      baseZ: -9.2,
      w: 11.2,
      h: 15.5,
      title: 'Cà Phê Mùa Hè Ghibli'
    },
    {
      file: '/assets/2.5d-layers/ghibli_bldg_2_indochine.png',
      x: -4.5,
      baseZ: -8.7,
      w: 9.36,
      h: 15.5,
      title: 'Biệt Thự Đông Dương'
    },
    {
      file: '/assets/2.5d-layers/ghibli_bldg_3_pharmacy.png',
      x: 3.5,
      baseZ: -9.4,
      w: 8.8,
      h: 15.5,
      title: 'Hiệu Thuốc Cổ Truyền'
    },
    {
      file: '/assets/2.5d-layers/ghibli_bldg_4_gift.png',
      x: 12.5,
      baseZ: -8.9,
      w: 13.2,
      h: 15.5,
      title: 'Tiệm Trà & Quà Lưu Niệm'
    }
  ],
  pixel: [
    {
      file: '/assets/2.5d-layers/pixel_bldg_1_cafe.png',
      x: -13.5,
      baseZ: -9.2,
      w: 10.8,
      h: 15.5,
      title: 'Pixel Café'
    },
    {
      file: '/assets/2.5d-layers/pixel_bldg_2_grocery.png',
      x: -4.5,
      baseZ: -8.7,
      w: 9.36,
      h: 15.5,
      title: 'Tạp Hóa Pixel 8-bit'
    },
    {
      file: '/assets/2.5d-layers/pixel_bldg_3_tailor.png',
      x: 3.5,
      baseZ: -9.4,
      w: 11.2,
      h: 15.5,
      title: 'Tiệm May Voxel'
    },
    {
      file: '/assets/2.5d-layers/pixel_bldg_4_pho.png',
      x: 12.5,
      baseZ: -8.9,
      w: 9.2,
      h: 15.5,
      title: 'Quán Phở Pixel'
    }
  ],
  paper: [
    {
      file: '/assets/2.5d-layers/paper_bldg_1.png',
      x: -13.5,
      baseZ: -9.2,
      w: 10.2,
      h: 15.5,
      title: 'Nhà Cắt Giấy Cổ 1'
    },
    {
      file: '/assets/2.5d-layers/paper_bldg_2.png',
      x: -4.5,
      baseZ: -8.7,
      w: 9.36,
      h: 15.5,
      title: 'Hiệu Sách Cắt Giấy'
    },
    {
      file: '/assets/2.5d-layers/paper_bldg_3.png',
      x: 3.5,
      baseZ: -9.4,
      w: 11.5,
      h: 15.5,
      title: 'Phố Cổ Thủ Công'
    },
    {
      file: '/assets/2.5d-layers/paper_bldg_4.png',
      x: 12.5,
      baseZ: -8.9,
      w: 10.5,
      h: 15.5,
      title: 'Tiệm Gốm Mộc'
    }
  ],
  cyber: [
    {
      file: '/assets/2.5d-layers/cyber_bldg_1.png',
      x: -13.5,
      baseZ: -9.2,
      w: 9.8,
      h: 15.5,
      title: 'Cyber Tower Alpha'
    },
    {
      file: '/assets/2.5d-layers/cyber_bldg_2.png',
      x: -4.5,
      baseZ: -8.7,
      w: 9.36,
      h: 15.5,
      title: 'Neon Arcade Plaza'
    },
    {
      file: '/assets/2.5d-layers/cyber_bldg_3.png',
      x: 3.5,
      baseZ: -9.4,
      w: 9.5,
      h: 15.5,
      title: 'Holo Tech Lab'
    },
    {
      file: '/assets/2.5d-layers/cyber_bldg_4.png',
      x: 12.5,
      baseZ: -8.9,
      w: 9.8,
      h: 15.5,
      title: 'Cyber Noodle Bar'
    }
  ]
};

// Tọa độ Z cơ sở của các tầng
export const BASE_Z = {
  bg: -22.0,
  center: 0.0,
  fg: 7.0
};
